// DOM render helpers for the setup status panel. These mutate the
// status container's children in place (badge, message, version, OS,
// action button). Each is small, predictable, and exported for the
// state-setter module to compose.
//
// The split between these helpers and the failure-UX module is purely
// scope-based: helpers in here all touch the always-present elements;
// the failure module owns the dynamic block that gets cleared and
// re-rendered for each failure shape.

// Friendly OS labels mirror /v1/diagnostics' (goos, goarch) — kept in
// sync with the ones the Rails diagnostics endpoint understands.
var FRIENDLY_OS_LABELS = {
  darwin_arm64: "macOS Apple Silicon",
  darwin_amd64: "macOS Intel",
  windows_amd64: "Windows 64-bit",
  windows_arm64: "Windows ARM64",
  windows_386: "Windows 32-bit",
  linux_amd64: "Linux 64-bit",
  linux_arm64: "Linux ARM64"
};

function friendlyOS(rawOS) {
  if (!rawOS) {
    return "";
  }
  return FRIENDLY_OS_LABELS[rawOS] || rawOS;
}

function statusMessages(container) {
  var ds = container.dataset;
  return {
    checking: ds.statusChecking,
    running: ds.statusRunning,
    notConnected: ds.statusNotConnected,
    badgeChecking: ds.statusBadgeChecking,
    badgeRunning: ds.statusBadgeRunning,
    badgeNotRunning: ds.statusBadgeNotRunning,
    badgeBlocked: ds.statusBadgeBlocked,
    versionPrefix: ds.statusVersionPrefix,
    versionUnavailable: ds.statusVersionUnavailable,
    osPrefix: ds.statusOsPrefix,
    osUnavailable: ds.statusOsUnavailable,
    connect: ds.statusConnect,
    refresh: ds.statusRefresh,
    refreshing: ds.statusRefreshing,
    retry: ds.statusRetry
  };
}

var BADGE_CLASSES = {
  running: "bg-success text-white",
  checking: "bg-secondary text-white",
  blocked: "bg-warning text-dark"
};

function badgeLabel(messages, kind) {
  if (kind === "running") {
    return messages.badgeRunning;
  }
  if (kind === "checking") {
    return messages.badgeChecking;
  }
  if (kind === "blocked") {
    return messages.badgeBlocked;
  }
  return messages.badgeNotRunning;
}

function setBadge(container, messages, kind) {
  var badge = container.querySelector(".js-chit-chats-print-status-badge");
  if (!badge) {
    return;
  }
  var classes = (BADGE_CLASSES[kind] || "bg-secondary text-white").split(" ");
  classes.forEach(function(cls) {
    badge.classList.add(cls);
  });
  badge.textContent = badgeLabel(messages, kind);
}

function setMessage(container, text) {
  var el = container.querySelector(".js-chit-chats-print-status-message");
  if (el) {
    el.textContent = text;
  }
}

function rawOSFromDiagnostics(diagnostics) {
  if (!diagnostics || !diagnostics.goos || !diagnostics.goarch) {
    return "";
  }
  return diagnostics.goos + "_" + diagnostics.goarch;
}

function applyVersion(versionEl, messages, version) {
  if (version) {
    versionEl.textContent = messages.versionPrefix + " " + version;
    versionEl.classList.remove("d-none");
  } else {
    versionEl.classList.add("d-none");
  }
}

function applyOS(osEl, messages, rawOS) {
  if (rawOS) {
    osEl.textContent = messages.osPrefix + " " + friendlyOS(rawOS);
    osEl.classList.remove("d-none");
  } else {
    osEl.classList.add("d-none");
  }
}

function setVersionAndOS(container, messages, diagnostics) {
  var versionEl = container.querySelector(".js-chit-chats-print-status-version");
  var osEl = container.querySelector(".js-chit-chats-print-status-os");
  if (!versionEl || !osEl) {
    return;
  }
  applyVersion(versionEl, messages, diagnostics && diagnostics.version);
  applyOS(osEl, messages, rawOSFromDiagnostics(diagnostics));
}

function setActionButton(actionBtn, label) {
  actionBtn.disabled = false;
  actionBtn.textContent = label;
}

export {
  statusMessages,
  setBadge,
  setMessage,
  setVersionAndOS,
  setActionButton
};
